import IMemberUserRepository from "../../../domain/interfaces/repositories/IMemberUserRepository";
import {UpdateMemberUserCommandRequest} from "../../../domain/entities/memberUser";

export const UpdateMemberUserCommand = (repository: IMemberUserRepository, data: UpdateMemberUserCommandRequest)=>{
    return repository.update(data)
}
